export const stripAnalystBio = (value) =>
  (value || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
